import React from 'react';
import ScreenerCard from './ScreenerCard';
import './Screeners.css';

const SCREENERS = [
    {
        id: '52-week-high',
        title: '52 Week High - Nifty 50',
        description: 'Top 20 Nifty 50 constituents and NSE stocks with derivatives trading within 10% of their 52-week high.',
        endpoint: '/api/screeners/52-week-high',
    },
];

function Screeners() {
    return (
        <div className="screeners-grid">
            {SCREENERS.map((screener) => (
                <ScreenerCard key={screener.id} {...screener} />
            ))}
        </div>
    );
}

export default Screeners;
